// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import ExhibitorPreviewPage from '@bottlebooks/gatsby-theme-event/src/components/Preview/ExhibitorPreviewPage';
import { jsx } from 'theme-ui';
import PreviewLinkProvider from '../../../../../../PreviewLinkProvider';

export default function ExhibitorPreview(props) {
  const { collectionId, companyId, locale } = props.params;
  return (
    <PreviewLinkProvider collectionId={collectionId} locale={locale}>
      <ExhibitorPreviewPage
        collectionId={collectionId}
        locale={locale}
        companyId={companyId}
      />
    </PreviewLinkProvider>
  );
}
